import http from "@/services/http";
import { EventBus } from "@/store/eventBus";

export async function getSystemDowntime() {
  const { data } = await http().get(
    globalThis.env.API_COMMERCE + "/system-downtime/COMMERCE_SYSTEM_DOWN_MESSAGE"
  );
  return data;
}

export async function getAnnouncementBanner() {
  const { data } = await http().get(
    globalThis.env.API_COMMERCE + "/system-downtime/CISCOU_ANNOUNCEMENT_BANNER"
  );
  return data;
}

const customerAdminExemptedTypes =
  "CTF,OPEN_EXAM_VOUCHER,LAB_VOUCHER,EXAM-VOUCHER,SAFEGUARD_OPEN_EXAM_VOUCHER,PRACTICE_EXAM,CISCO_LEARNING_LAB,CISCO_MODELING_LAB,GRADED_LAB,PRACTICE_LAB"
    .split(",")
    .map((type: string) => type.trim().toUpperCase());

export function isCustomerAdminExemptedProduct(productType: string) {
  if (!productType) {
    return false;
  }
  return customerAdminExemptedTypes.includes(productType?.toUpperCase());
}

const learnerRequiredTypes = new Set(
  ("BUNDLE," + customerAdminExemptedTypes)
    .split(",")
    .map((type: string) => type.trim().toUpperCase())
);

export function isLearnerRequiredProduct(productType: string) {
  if (!productType) {
    return false;
  }
  return learnerRequiredTypes.has(productType?.toUpperCase());
}

export function isCMLProduct(productType: string): boolean {
  return productType?.toUpperCase() == "CISCO_MODELING_LAB";
}

export function copyTextToClipboard(text: string, successMessage: string, errorMessage: string) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      EventBus.emit("showToast", {
        message: successMessage,
        type: "SUCCESS",
      });
    })
    .catch((error) => {
      EventBus.emit("showToast", {
        message: errorMessage,
        type: "ERROR",
      });
    });
}

export function downloadCMLFile() {
  globalThis.open(globalThis.env.CML_DOWNLOAD_LINK, "_blank", "noopener");
}

export function getItemLearnerEmails(item: any, skipLearnerEmail: string = ""): string[] {
  let learnerEmails = item?.order_line_item_contacts
    ?.filter((c: any) => c && c.contact_type?.id === "LEARNER" && c.email && !c.deleted_at)
    .map((c: any) => String(c.email?.toLowerCase()).trim())
    .filter(
      (email: string) => email !== "" && email?.toLowerCase() !== skipLearnerEmail?.toLowerCase()
    );
  return learnerEmails;
}

export function getCMLLearnerDetails(item: any, skipLearnerEmail: string = ""): any[] {
  let learnerDetails = item?.order_line_item_contacts
    ?.filter((c: any) => c && c.contact_type?.id === "LEARNER" && c.email && !c.deleted_at)
    .map((c: any) => ({
      email: String(c.email?.toLowerCase()).trim(),
      startDate: c.subscription_start_date,
      endDate: c.subscription_end_date,
    }))
    .filter(
      (c: any) => c.email !== "" && c.email?.toLowerCase() !== skipLearnerEmail?.toLowerCase()
    );
  return learnerDetails;
}

export function isGradedLabProduct(productId: string, gradedLabs: any[]): boolean {
  return gradedLabs.some((lab) => lab.product_id + "" == productId + "");
}

export function isCCIEPracticeLab(productType: string): boolean {
  return productType?.toUpperCase() === "CCIE_PRACTICE_LAB";
}
